import { dentroDe, limitesDoMes } from '../tempo/limitesDoMes.js';
import { limitarCreditos } from './creditos.js';
import { estudosDoMes } from './estudos.js';
import { fecharHoras, minutosDoMes } from './horas.js';
// Desde novembro de 2023 o publicador só relata participação e estudos;
// horas e créditos ficam para pioneiros e servos de tempo integral.
export function relataHoras(tipo) {
    return tipo !== 'publicador' && tipo !== 'nao_batizado';
}
function houveVisitaNoMes(visitas, ano, mes) {
    const limites = limitesDoMes(ano, mes);
    return visitas.some((v) => !v.deleted && dentroDe(v.em, limites));
}
export function calcularMes(entrada) {
    const { ano, mes, perfil, existente } = entrada;
    const agora = entrada.agora ?? new Date();
    const minutos = minutosDoMes(entrada.sessoes, ano, mes, agora);
    const { horas, transporte } = fecharHoras(minutos.campo, entrada.transporteAnterior);
    const calculado = {
        // "Participou" pede ao menos um minuto inteiro no total. O truncamento é
        // um só, sobre a soma em milissegundos (`minutosDoMes`), e não por
        // sessão: uma sessão sozinha de quarenta segundos não conta, mas duas
        // delas somam um minuto e contam.
        participou: minutos.campo > 0 ||
            minutos.creditos > 0 ||
            houveVisitaNoMes(entrada.visitas, ano, mes),
        estudos: estudosDoMes(entrada.estudos, entrada.visitas, ano, mes),
        horas_minutos: horas * 60,
        creditos_minutos: limitarCreditos(minutos.creditos),
    };
    // `participou` é derivado, nunca trinco: apagar a última sessão do mês
    // tem de desmarcar. A edição manual continua possível — quem marca à mão
    // marca o mês como `sobrescrito`, e aí nada é recalculado. Um trinco
    // sobre o cálculo deixaria o usuário sem como corrigir um engano.
    const totais = existente?.sobrescrito
        ? {
            participou: existente.participou,
            estudos: existente.estudos,
            horas_minutos: existente.horas_minutos,
            creditos_minutos: existente.creditos_minutos,
        }
        : calculado;
    // Mês sobrescrito também congela o transporte: um cálculo rejeitado
    // pelo usuário não pode deixar seu resto vazar para o mês seguinte.
    const transporteMinutos = existente?.sobrescrito
        ? existente.transporte_minutos
        : transporte;
    // updated_at é o árbitro do LWW: só avança quando algum total mudou,
    // senão abrir o app num aparelho venceria uma edição real feita em
    // outro.
    const nadaMudou = existente !== undefined &&
        totais.participou === existente.participou &&
        totais.estudos === existente.estudos &&
        totais.horas_minutos === existente.horas_minutos &&
        totais.creditos_minutos === existente.creditos_minutos &&
        transporteMinutos === existente.transporte_minutos;
    return {
        id: existente?.id ?? entrada.id,
        user_id: existente?.user_id ?? perfil.user_id,
        updated_at: nadaMudou ? existente.updated_at : agora.toISOString(),
        server_updated_at: existente?.server_updated_at ?? null,
        deleted: false,
        ano,
        mes,
        ...totais,
        observacao: existente?.observacao ?? '',
        enviado_em: existente?.enviado_em ?? null,
        transporte_minutos: transporteMinutos,
        sobrescrito: existente?.sobrescrito ?? false,
    };
}
const NOMES_DOS_MESES = [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro',
];
export function nomeDoMes(mes) {
    return NOMES_DOS_MESES[mes - 1] ?? '';
}
export function textoDoRelatorio(mes, perfil) {
    const linhas = [
        `Relatório de serviço de campo — ${nomeDoMes(mes.mes)} de ${mes.ano}`,
        `Participei no ministério: ${mes.participou ? 'Sim' : 'Não'}`,
        `Estudos bíblicos: ${mes.estudos}`,
    ];
    if (relataHoras(perfil.tipo)) {
        linhas.push(`Horas: ${Math.floor(mes.horas_minutos / 60)}`);
        if (mes.creditos_minutos > 0) {
            linhas.push(`Créditos: ${Math.floor(mes.creditos_minutos / 60)} h`);
        }
    }
    if (mes.observacao.trim() !== '')
        linhas.push(`Observações: ${mes.observacao.trim()}`);
    return linhas.join('\n');
}
//# sourceMappingURL=mes.js.map